const mediaItems = [
  {
    title: '台北娜娜最新直播高能片段',
    duration: '03:28',
    views: '128.5万',
    img: 'https://readdy.ai/api/search-image?query=Warm%20coral%20pink%20abstract%20digital%20art%2C%20playful%20flowing%20shapes%2C%20entertainment%20video%20thumbnail%20style%2C%20modern%20youth%20culture%2C%20soft%20gradients%2C%20clean%20vibrant%20composition&width=640&height=360&seq=media-01&orientation=landscape',
    alt: '台北娜娜最新直播高能片段',
    tag: 'HOT',
  },
  {
    title: '玩偶姐姐回应争议完整版',
    duration: '05:12',
    views: '96.3万',
    img: 'https://readdy.ai/api/search-image?query=Warm%20amber%20peach%20abstract%20art%2C%20dynamic%20curves%2C%20video%20media%20theme%2C%20soft%20glowing%20highlights%2C%20modern%20entertainment%20style%2C%20clean%20background&width=640&height=360&seq=media-02&orientation=landscape',
    alt: '玩偶姐姐回应争议完整版',
    tag: 'NEW',
  },
  {
    title: '莫里秀吃瓜短视频精选集',
    duration: '02:45',
    views: '87.1万',
    img: 'https://readdy.ai/api/search-image?query=Warm%20rose%20coral%20abstract%20geometric%20composition%2C%20playful%20digital%20shapes%2C%20short%20video%20theme%2C%20vibrant%20soft%20colors%2C%20modern%20youthful%20aesthetic%2C%20clean%20minimal%20design&width=640&height=360&seq=media-03&orientation=landscape',
    alt: '莫里秀吃瓜短视频精选集',
    tag: 'HOT',
  },
  {
    title: '网红直播翻车搞笑合集',
    duration: '04:56',
    views: '73.8万',
    img: 'https://readdy.ai/api/search-image?query=Warm%20orange%20coral%20abstract%20fluid%20art%2C%20bubbly%20energetic%20shapes%2C%20funny%20entertainment%20theme%2C%20glowing%20soft%20gradients%2C%20modern%20playful%20style%2C%20clean%20composition&width=640&height=360&seq=media-04&orientation=landscape',
    alt: '网红直播翻车搞笑合集',
    tag: '',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-foreground-950 text-center mb-3">
          精彩视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          吃瓜娱乐现场热门短视频速览
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-2xl border border-background-200/80 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-500 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-background-50 text-xs rounded whitespace-nowrap">
                  {item.duration}
                </div>
                {item.tag && (
                  <div className="absolute top-2 left-2">
                    <span className={`px-2 py-0.5 rounded-full text-xs font-semibold whitespace-nowrap ${
                      item.tag === 'HOT'
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-accent-500 text-background-50'
                    }`}>
                      {item.tag}
                    </span>
                  </div>
                )}
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}